import * as React from "react";
const SvgFiRrTrack = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-track_svg__a)">
      <path
        fill="#062147"
        d="M17.247 10.279a2.5 2.5 0 0 0 1.753.709c.635 0 1.27-.236 1.752-.709l1.783-1.744a5.005 5.005 0 0 0 0-7.071A4.97 4.97 0 0 0 19 0c-1.335 0-2.591.52-3.536 1.464a5.01 5.01 0 0 0 .008 7.079zm-.369-7.4A2.98 2.98 0 0 1 19 2a3 3 0 0 1 2.129 5.113l-1.775 1.736a.507.507 0 0 1-.708 0l-1.767-1.728a3.005 3.005 0 0 1 0-4.243zM4 22a2 2 0 1 1-3.999.001A2 2 0 0 1 4 22m10.5-6a2 2 0 1 1-3.999.001A2 2 0 0 1 14.5 16M2 13c0-2.206 1.794-4 4-4h7a1 1 0 0 1 0 2H6c-1.103 0-2 .897-2 2s.897 2 2 2h2a1 1 0 0 1 0 2H6c-2.206 0-4-1.794-4-4m22 6c0 2.206-1.794 4-4 4H7a1 1 0 0 1 0-2h13c1.103 0 2-.897 2-2s-.897-2-2-2h-3a1 1 0 0 1 0-2h3c2.206 0 4 1.794 4 4M20.001 4.787a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-track_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTrack;
